import { forwardRef, memo } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    desc,
    descId,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    className: "interstate-home-icon",
    ref: ref,
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    ...props,
    children: [desc ? /*#__PURE__*/_jsx("desc", {
      id: descId,
      children: desc
    }) : null, title ? /*#__PURE__*/_jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M8.146 1.84a.206.206 0 00-.292 0L3.087 6.608v7.218c0 .113.092.205.205.205h2.421v-2.975c0-.804.652-1.455 1.456-1.455h1.662c.804 0 1.456.651 1.456 1.455v2.975h2.42a.206.206 0 00.206-.206V6.609L8.145 1.84zm5.834 4.066L9.03.956a1.456 1.456 0 00-2.06 0l-4.95 4.95L.358 7.568a.625.625 0 00.884.884l.595-.594v5.968c0 .803.651 1.455 1.455 1.455h9.416c.804 0 1.455-.652 1.455-1.456V7.859l.595.594a.625.625 0 00.884-.884L13.98 5.906zm-4.943 8.125H6.963v-2.975c0-.113.093-.205.206-.205h1.662c.113 0 .206.092.206.205v2.975z"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
const Memo = /*#__PURE__*/memo(ForwardRef);

// eslint-disable-next-line react/no-multi-comp
export const HomeIcon = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Memo, {
    ...props,
    ref: ref
  });
});
HomeIcon.displayName = 'HomeIcon';